module.exports = __webpack_public_path__ + "static/media/logo.a75afb2b.svg";